import * as actions from './constants';

const initialState: FutureSecurityState = {
  isLoadingTerminals: false,
  isLoadingMetricDefinitions: false,
  isLoadingMetricValues: false,
  error: undefined,
  updatePending: false,
  updateSuccess: false,
  validationError: undefined,
  terminals: [],
  metrics: [],
  cells: [],
  lanes: [],
  metric: undefined
}

const reducer = (
  state: FutureSecurityState = initialState,
  action: MetricsAction
  ): FutureSecurityState => {
  switch (action.type) {
    case actions.GET_METRIC:
      if(action.response.error) {
        return { ...state, isLoadingMetricValues: false, error: action.response.error };
      }
      return { ...state, isLoadingMetricValues: false, validationError: undefined, viewMetricDetails: action.response}
    case actions.SET_LOADING_METRICS:
      return { ...state, isLoadingMetricValues: true, error: undefined }
    case actions.LOAD_METRICS:
      if (action.response.error) {
        return { ...state, isLoadingMetricValues: false, error: action.response.error };
      }
      return {
        ...state,
        isLoadingMetricValues: false,
        metrics: action.response.metrics
      }
      case actions.SET_LOADING_METRIC_DEFINITIONS:
        return { ...state, isLoadingMetricDefinitions: true, error: undefined }
      case actions.LOAD_METRIC_DEFINITIONS:
        if (action.response.error) {
          return { ...state, isLoadingMetricDefinitions: false, error: action.response.error };
        }
        return {
          ...state,
          isLoadingMetricDefinitions: false,
          metrics: action.response.metrics,
          cells: action.response.cells,
          lanes: action.response.lanes
        }
    case actions.SET_UPDATING_TARGET:
      return {
        ...state, updatePending: true, updateSuccess: false
      }
    case actions.UPDATE_TARGET:
      if(action.response.error) {
        return { ...state, updatePending: false, updateSuccess: false, validationError: action.response.error}
      }
      return {
        ...state, updatePending: false, validationError: undefined, updateSuccess: true 
      }
    case actions.LOAD_TERMINALS:
      if(action.response.error) {
        return { ...state, isLoadingTerminals: false, error: action.response.error }
      }
      return {
        ...state, 
        isLoadingTerminals: false,
        terminals: action.response.terminals,
        error: undefined
      }
    case actions.SET_LOADING_TERMINALS:
      return {
        ...state,
        isLoadingTerminals: true
      }
    case actions.SET_VALIDATION_ERROR:
      return {
        ...state,
        validationError: action.response.error,
        updatePending: false,
        updateSuccess: false
      }
    case actions.CLEAR_VALIDATION_ERROR:
      return {
        ...state,
        updatePending: false,
        error: undefined,
        updateSuccess: false,
        validationError: undefined
      }
    default: return state;
  }
}

export default reducer